import { Responsive } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { Utilities } from '../../../components/Utilities';
import { selectIsExperimentGroupNameB } from '../../../selectors/experiments/myHomeRedesign';
import { selectIsAuthenticated, selectIsRealtor } from '../../../selectors/user';
import { IApplicationState } from '../../../types/redux';
import { UtilityCompareContainer } from '../../UtilityCompareContainer';
import { UtilityFavoritesContainer } from '../../UtilityFavoritesContainer/Redesign';
import { UtilityMessagesContainer } from '../../UtilityMessagesContainer';
import { UtilityMyHomeContainer } from '../../UtilityMyHomeContainer';
import { UtilityNotificationsContainer } from '../../UtilityNotificationsContainer';
import { UtilitySavedSearchesContainer } from '../../UtilitySavedSearchesContainer';

export const UtilitiesContainer: React.FC = () => {
  const isAuthenticated = useSelector<IApplicationState, boolean>(selectIsAuthenticated);
  const isRealtor = useSelector<IApplicationState, boolean>(selectIsRealtor);

  const isExperimentGroupB = useSelector(selectIsExperimentGroupNameB);
  const testId = isExperimentGroupB ? 'UtilitiesRedesignB' : 'UtilitiesRedesignC';

  return (
    <Utilities testId={testId}>
      <UtilityCompareContainer />
      <UtilityMessagesContainer />
      <UtilityFavoritesContainer />
      {isAuthenticated && (
        <Responsive phone tablet>
          <UtilitySavedSearchesContainer />
        </Responsive>
      )}
      <UtilityNotificationsContainer />
      {!isRealtor && (
        <Responsive desktop>
          <UtilityMyHomeContainer />
        </Responsive>
      )}
    </Utilities>
  );
};
